import { render } from "./wysiwyg.vue?vue&type=template&id=fa8dba5a"
import script from "./wysiwyg.vue?vue&type=script&lang=js"
export * from "./wysiwyg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__